import { cva, type VariantProps } from 'class-variance-authority'


export const dialogContentVariants = cva(
  'flex flex-col max-h-[85vh] p-0 gap-0 rounded-xl rounded-tr-none',
  {
    variants: {
      size: {
        default: 'sm:max-w-[656px] max-w-[calc(100%-2rem)]',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

export const dialogBodyVariants = cva('relative z-10')

export const backgroundImageVariants = cva(
  'absolute top-0 left-0 w-full h-full z-0 pointer-events-none'
)

export const dialogTitleVariants = cva('px-6 pt-6 sm:pt-8')

export const couponRichTextVariants = cva(
  'text-left space-y-1 [&_p]:!mb-0 [&_h1]:!mb-0 [&_h2]:!mb-0 [&_h3]:!mb-0 [&_h4]:!mb-0 [&_h5]:!mb-0'
)

export const phoneImageVariants = cva(
  'w-full max-w-[280px] sm:max-w-[350px] h-auto mx-auto z-10'
)

export const footerWrapperVariants = cva(
  'p-4 pt-0 h-1/3 relative z-10'
)

export const dialogFooterVariants = cva(
  'flex !flex-col items-center justify-center py-4',
  {
    variants: {
      variant: {
        default: 'bg-[#F6C500]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const footerTitleVariants = cva(
  'text-center text-black font-medium pt-4',
  {
    variants: {
      size: {
        default: 'text-2xl sm:text-3xl',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

export const appStoreLinksVariants = cva(
  'flex items-center justify-center py-4',
  {
    variants: {
      gap: {
        default: 'gap-2 sm:gap-4',
      },
    },
    defaultVariants: {
      gap: 'default',
    },
  }
)

export const appStoreImageVariants = cva('h-auto', {
  variants: {
    size: {
      default: 'w-[140px] sm:w-[170px] md:w-[200px]',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})
